module.exports = __webpack_public_path__ + "img/192.426f6d17.jpg";